import React, { Component } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import quillEmoji from "react-quill-emoji";
import "./editor-box.scss";
import "react-quill-emoji/dist/quill-emoji.css";

class EditorBox extends Component {
    constructor(props) {
        super(props);
        // this.reactQuillRef = React.createRef();
        this.state = { text: "", count: 0 };
        this.modules = {
            toolbar: [
                [{ font: [] }],
                [{ size: ["small", false, "large", "huge"] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                [{ color: ["#3DC9A9"] }, { background: ["#3DC9A9"] }],
                ["link"],
            ],
        };

        if (props.GenericBannerModal) {
            this.modules.toolbar = [
                [{ list: "ordered" }, { list: "bullet" }],
                ["bold", "italic", "underline"],
                ["link"],
            ];
        }

        if (props.notification) {
            this.modules = {
                toolbar: {
                    container: [],
                },
                // "emoji-toolbar": true,
                "emoji-shortname": true,
                "emoji-textarea": true,
            };
        }

        if (props.replyemail) {
            this.modules.toolbar = [
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["link"],
            ];
        }

        if (props.h1h2) {
            this.modules.toolbar = [
                [{ font: [] }],
                [{ header: [] }],
                ["bold", "italic", "underline"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                [{ color: ["#d42512", "black"] }, { background: ["#d42512", "white"] }],
                ["link"],
            ];
        }

        this.formats = [
            "font",
            "size",
            "bold",
            "italic",
            "underline",
            "list",
            "bullet",
            "align",
            "color",
            "background",
            "link",
        ];

        if (props.GenericBannerModal) this.formats = ["list", "bullet", "link", "bold", "italic", "underline"];
        if (props.notification) this.formats = ["font" ,"bold", "italic", "color" , "emoji" , "clear"];

        if (props.h1h2)
            this.formats = [
                "font",
                "header",
                "bold",
                "italic",
                "underline",
                "list",
                "bullet",
                "align",
                "color",
                "background",
                "link",
            ];
    }

	charactorcountor =(event) =>{
		if(this.props.maxLength){
			let cleanText = this.state.text.replace(/<\/?[^>]+(>|$)/g, "");
			if(cleanText.length >= this.props.maxLength && ! ['Backspace','ArrowUp','ArrowDown','ArrowLeft','ArrowRight'].find((item)=>item === event.key))
				event.preventDefault();
		}
	}
    handleChange = (value) => {
        this.setState({ text: value });
        this.props.getText(value);
    };

    componentDidMount = () => {
        if (this.props.value) this.setState({ text: this.props.value });
    };

    componentWillReceiveProps = (props) => {
        this.setState({ text: props.value });
    };

    render() {
        Quill.register(
            {
                "formats/emoji": quillEmoji.EmojiBlot,
                "modules/emoji-toolbar": quillEmoji.ToolbarEmoji,
                "modules/emoji-textarea": quillEmoji.TextAreaEmoji,
                "modules/emoji-shortname": quillEmoji.ShortNameEmoji,
            },
            true
        );

        return (
            <div className='quill-container'>
                <ReactQuill
					onKeyDown={this.charactorcountor}
                    value={this.state.text}
                    theme='snow'
                    modules={this.modules}
                    formats={this.formats}
                    onChange={this.handleChange}
                    placeholder={this.props?.placeholder}
                    className={`react-quill-component ${this.props.className}`}
                    style={{ height: this.props.height, marginTop: "8px", borderRadius: "5px", ...this.props?.style }}
                />
            </div>
        );
    }
}

export default EditorBox;
